import { IonPopover } from '@ionic/react';
import { isPlatform } from '../utils/isPlatform';
import { FC } from 'react';
import { MenuList } from '../components/Menu';
import { DuoAddressCardIcon, DuoEditIcon } from '../theme/Icons';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CareMapState } from '../caremap/CareMapState';

export type IAddFromPopoverProps = {
    isOpen?: boolean;
    onDidDismiss?: () => void;
    trigger?: string;
    buttonHandlers: {
        manually: () => void;
        fromContacts: () => void;
    }
};

export const AddFromPopover: FC<IAddFromPopoverProps> = ({ isOpen, trigger, onDidDismiss = ()=>{}, buttonHandlers }) => {
    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const caremap = careMapState.getActiveCaremap();

    if (!caremap) {
        return null;
    }

    return (
        isPlatform('capacitor') && (
            <IonPopover
                side="top"
                alignment="center"
                showBackdrop={false}
                trigger={trigger}
                isOpen={isOpen}
                onDidDismiss={onDidDismiss}

                // need to set keepContentsMounted, otherwise content that expands popover
                // beyond minWidth sometimes pushes it off the right side of the screen
                // (see https://github.com/ionic-team/ionic-framework/issues/24716)
                keepContentsMounted
            >
                <MenuList
                    actions={[
                        {
                            text: 'Manually',
                            Icon:  DuoEditIcon,
                            handler: () => {
                                onDidDismiss();
                                buttonHandlers.manually();
                            }
                        },
                        {
                            text: 'From Contacts',
                            Icon:  DuoAddressCardIcon,
                            handler: () => {
                                onDidDismiss();
                                buttonHandlers.fromContacts();
                            }
                        }
                    ]}
                />
            </IonPopover>
        )
    );
};
